import { useDisclosure } from '@mantine/hooks';
import { useCallback, useState } from 'react';

export enum ECRMModalStep {
  SelectCRM = 0,
  BlackbaudAddApp = 1,
  BlackbaudConnect = 2,
  BlackbaudEnableSync = 3,
}

export interface IProps {
  isOpen: boolean;
  initialStep: number;
  openModal: (step?: number) => void;
  closeModal: () => void;
}

export function useCRMConnectModal(): IProps {
  const [isOpen, { open, close }] = useDisclosure(false);
  const [initialStep, setInitialStep] = useState(0);

  const openModal = useCallback(
    (step = 0) => {
      setInitialStep(step);
      open();
    },
    [open],
  );

  const closeModal = useCallback(() => {
    setInitialStep(0);
    close();
  }, [close]);

  return {
    isOpen,
    initialStep,
    openModal,
    closeModal,
  };
}
